document.addEventListener('DOMContentLoaded', function() {
  let changeBtn = document.querySelectorAll('.display_switch');
  let lineup = document.getElementById('lineup');
  let tabChange = document.querySelectorAll('.tab_change');
  let itemList = document.querySelectorAll('.item_list');
  let totalPosts = document.querySelectorAll('.total_posts_num');
  let fadeSpeed = 200;    // Glid, Listの切り替えスピード
  let postCount = 0;      // 投稿件数カウント用

  postsCount('industry_list');

  // 表示コンテンツ切り替え
  $('.unused_only').css({
    'cssText': 'display: none !important'
  });
  let tabChangeNode = Array.prototype.slice.call(tabChange,0);
  tabChangeNode.forEach(function(tab) {
    tab.addEventListener('change', function() {
      let current = '.' + this.id + '_only';
      let $activate = $(current);
      $('.unused_only, .industry_only').css({
        'cssText': 'display: none !important'
      });
      postsCount(this.id + '_list');
      // コンテンツ表示
      $activate.css('display', '');
    });
  });

  // フォームリセット
  let form = document.getElementById('search_form');
  let formReset = document.getElementById('reset_button');

  formReset.addEventListener('click', function() {
    let formCheckBoxes = form.querySelectorAll('input[type="checkbox"]');
    let formSlects = form.querySelectorAll('select');
    let checkBoxes = Array.prototype.slice.call(formCheckBoxes,0);
    let selects = Array.prototype.slice.call(formSlects,0);
    // チェックボックスリセット
    checkBoxes.forEach(function(checkbox) {
      checkbox.checked = false;
    });
    // セレクトボックスリセット
    selects.forEach(function(select) {
      select.value = "";
    });
  });

  // セレクトボックス ------------------------------------------------
  let $selectBox = $('#filter_trigger');
  let $sortFilter = $('.sort_filter');

  if(isSmartPhone()) {
    $('#filter_txt').on('click', function() {
      $sortFilter.stop(true).animate({
        height: '100px'
      }, 200);
    });
  } else {
    $selectBox.on('mouseenter', function() {
      $sortFilter.stop(true).animate({
        height: '100px'
      }, 200);
    });
  }

  $selectBox.on('mouseleave', function() {
    $sortFilter.stop(true).animate({
      height: '0'
    }, 200);
  });

  // クリック時のテキスト切り替え
  $sortFilter.find('li').on('click', function() {
    document.querySelector('#filter_txt a').textContent = this.textContent;
    $sortFilter.stop(true).animate({
      height: '0'
    }, 200);
    // セレクトボックスによるソート
    sortListBySelectBox(this.dataset.sortValue);
  });
  // // セレクトボックス ------------------------------------------------


  // 一覧の表示を切り替え
  let changeBtnNode = Array.prototype.slice.call(changeBtn,0);
  changeBtnNode.forEach(function(button) {
    button.addEventListener('click', function() {
      let type = this.getAttribute('data-list-type');
      changeListType(type);
    });
  });

  // 一覧表示の切り替え機能削除: Viewportwidth <= 925
  // リサイズ時に処理
  window.addEventListener('resize', function() {
    let currentWidth = window.innerWidth;
    // 規定画面幅以下になったら処理
    if(currentWidth < 1080){
      document.getElementById('switch').classList.add('none');
      let preList = document.querySelectorAll('.item_list');
      let preListNode = Array.prototype.slice.call(preList,0);
      preListNode.forEach(function(preList) {
        // 既にグリッドなら処理しない
        if(preList.classList.contains('type_is_glid')) return;
        // グリッドにする
        preList.classList.remove('type_is_list');
        preList.classList.add('type_is_glid');
      });
      // -----------------------------------
    } else {
      document.getElementById('switch').classList.remove('none');
    }
  });

  // フッタースティッキーメニューの表示 -------------------------------------------
  let footerBtn = document.getElementById('change_condition');
  window.addEventListener('scroll', function() {
    // トリガーまでの距離を取得: 基準は画面上端
    let tgrOffset = document.getElementById('search_land').getBoundingClientRect().top + window.innerHeight;
    // フッターまでの距離を取得: 基準は画面下端
    let footerOffset = document.querySelector('.related_link_blk').getBoundingClientRect().top - window.innerHeight;
    // トリガー位置を超える かつ ボタンが非表示なら
    if (tgrOffset < 0) {
      // 既に表示されていれば何もしない
      if (!footerBtn.classList.contains('is_active')) {
        // ボタン表示
        footerBtn.classList.add('is_active');
      }
    } else {
      // ボタン非表示
      footerBtn.classList.remove('is_active');
    }
    // フッターにさしかかると非表示 
    if (footerOffset < 0) {
      footerBtn.classList.add('is_hide');
    } else {
      footerBtn.classList.remove('is_hide');
    }
  });

  // フッタースティッキーメニューアンカー -------------------------------------------
  // イージング設定
  const ScrollEase = {
    easeInOut: function (t) {
      var ccc = 0;
      if (t < .5) {
          ccc = 4 * t * t * t;
      } else {
          ccc = (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
      }
      return ccc;
    }
  }

  let duration = 470;
  footerBtn.addEventListener('click', function() {
    // スクロール先座標を取得
    let targetOffset = window.pageYOffset + document.getElementById('search_land').getBoundingClientRect().top;
    // 現在のスクロール位置を取得
    let currentPostion = document.documentElement.scrollTop || document.body.scrollTop;
    // クリック時点での時間を取得
    let startTime = performance.now();
    // アニメーションを定義
    var smoothScroll = function(nowTime) {
      // 経過時間
      let elapsedTime = nowTime - startTime;
      let elapsedNormalize = elapsedTime / duration;
      // 経過時間がdurationに達していない場合は実行
      if(elapsedNormalize < 1) {
        window.scrollTo(0, currentPostion + ((targetOffset - currentPostion) * ScrollEase.easeInOut(elapsedNormalize)));
        // アニメーションを継続
        requestAnimationFrame(smoothScroll);
        // duration に経過時間が達したら、アニメーションを終了
      } else {
        window.scrollTo(0, targetOffset);
      }
    };
    requestAnimationFrame(smoothScroll);
  });

  // 一覧のタイトル部分の文字間調整<span>挿入
  let separateElemList = document.querySelectorAll('.block_wrap dt');
  let resultText = [];
  let separateElemListNode = Array.prototype.slice.call(separateElemList,0);
  separateElemListNode.forEach(function(elem) {
    let separateText = elem.textContent;
    resultText = separateText.split('').map(function(value) {
      let span = document.createElement('span');
      span.textContent = value;
      return span;
    });
    elem.textContent = '';
    resultText.forEach(function(span) {
      elem.appendChild(span);
    });
  });



  function isSmartPhone() {
    if (window.matchMedia && window.matchMedia('(max-device-width: 480px)').matches) {
      return true;
    } else {
      return false;
    }
  }

  function changeListType(type) {
    let currentList = document.querySelector('.item_list');
    if(currentList.classList.contains(type)) return;
    let itemListNode = Array.prototype.slice.call(itemList,0);
    itemListNode.forEach(function(itemList) {
      itemList.classList.add('list_hide');
      setTimeout(function(){
        itemList.classList.add(type);
      }, fadeSpeed);
      setTimeout(function() {
        if(type == 'type_is_glid') {
          itemList.classList.remove('type_is_list');
        } else if(type == 'type_is_list') {
          itemList.classList.remove('type_is_glid');
        }
        itemList.classList.remove('list_hide');
        itemList.classList.add(type, 'item_list');
      }, fadeSpeed * 1.3);
    });
  }

  function postsCount(currentID) {
    // 表示対象の投稿件数をカウント
    for (let i = 0; i < $('#' + currentID).find('.item_list_child').length; i++) {
      postCount++;
    }
    // 投稿件数挿入
    let totalPostsNode = Array.prototype.slice.call(totalPosts,0);
    totalPostsNode.forEach(function(posts) {
      posts.textContent = postCount;
    });
    // カウントリセット
    postCount = 0;
  }

  function sortListBySelectBox(data) {
    // sort_by_ の後ろ
    let sortBy = data.split('_').pop();
    // 各リストごとに処理
    let itemListNode = Array.prototype.slice.call(itemList,0);
    itemListNode.forEach(function(list) {
      let children = list.querySelectorAll('.item_list_child');
      let childrenNode = Array.prototype.slice.call(children,0);
      // 各li要素と、選択されたdata属性をハッシュで保存
      childrenNode.sort(function(a, b) {
        if(sortBy == 'date') {
          // 新着順にソート
          var dataA = a.getAttribute('data-post-' + sortBy);
          var dataB = b.getAttribute('data-post-' + sortBy);
        } else {
          // 面積系の順にソート
          if(isNaN(parseInt(a.getAttribute('data-post-' + sortBy)))) {
            // 数値ではないとき
            var dataA = -1;
          } else {
            // 数値のとき
            var dataA = parseFloat(a.getAttribute('data-post-' + sortBy));
          }
          if(isNaN(parseInt(b.getAttribute('data-post-' + sortBy)))) {
            // 数値ではないとき
            var dataB = -1;
          } else {
            // 数値のとき
            var dataB = parseFloat(b.getAttribute('data-post-' + sortBy));
          }
        }
        return (dataA > dataB) ? -1 : (dataA < dataB) ? 1 : 0;
      });
      // 子要素をクリア
      while (list.firstChild) list.removeChild(list.firstChild);
      // ソートした順に再度要素を挿入
      childrenNode.forEach(function(sorted) {
        list.appendChild(sorted);
      });
    });

  }
});